import { SxProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLanguageStore } from "../../stores";
import { TypographyExploreDescription, TypographyExploreTitle } from "../../styles/global_styles";

type ITitleAndSubtitle = {
    title?: string,
    subTitle?: string,
    sxSubTitle?: SxProps,
    sxTitle?: SxProps
}

export const TitleAndSubtitle =({
  title,
  subTitle,
  sxSubTitle,
  sxTitle
}: ITitleAndSubtitle) => {

  const { t } = useTranslation();
  const language = useLanguageStore(state => state.language)?.id;
  const isRTL = language === "ar";
  let accessibilitySubtitle = subTitle;

  if(accessibilitySubtitle?.toString().includes("|")){
    accessibilitySubtitle = accessibilitySubtitle.toString().replace(/\|/g, t("and"));
  }

  const slug = (title || subTitle || "section").toString().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") || "section";

  return (
    <>
      { title && (
        <TypographyExploreTitle
          id={ `title-and-subtitle-${slug}-title` }
          data-testid="title-and-subtitle-title"
          tabIndex={ title ? 0 : -1 }
          aria-label={ title }
          sx={ sxTitle }
          $isRTL={ isRTL }
        >
          { title }
        </TypographyExploreTitle>
      ) }
      { subTitle && (
        <TypographyExploreDescription
          id={ `title-and-subtitle-${slug}-subtitle` }
          data-testid="title-and-subtitle-subtitle"
          tabIndex={ subTitle ? 0 : -1 }
          aria-label={ accessibilitySubtitle }
          sx={ sxSubTitle }
          $isRTL={ isRTL }
        >
          { subTitle }
        </TypographyExploreDescription>
      )

      }
    </>
  );
};
